/**
 * Currency utilities for converting USD-based pricing to Algerian Dinar (DZ).
 * All product data remains in USD; we convert and format for display.
 */

// Approximate real-world exchange rate; adjust as needed
export const USD_TO_DZD_RATE = 135;

const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export const toDZD = (usd) => {
  return Math.round(toNumber(usd) * USD_TO_DZD_RATE);
};

// Format from USD source amount to DZ display (rounded, no decimals)
export const formatDZ = (usd, { prefix = 'DZ', decimals = 0 } = {}) => {
  const dz = toDZD(usd);
  const formatted = dz.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return prefix ? `${prefix} ${formatted}` : formatted;
};

// Format when the input value is already DZD
export const formatDZFromDZD = (dz, { prefix = 'DZ', decimals = 0 } = {}) => {
  const v = Math.round(toNumber(dz));
  const formatted = v.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return prefix ? `${prefix} ${formatted}` : formatted;
};

export const formatDZRange = (minUsd, maxUsd, opts) => {
  return `${formatDZ(minUsd, opts)} - ${formatDZ(maxUsd, opts)}`;
};

// Convert labels like "Save $50" to DZ equivalent
export const convertSaveLabel = (badgeString) => {
  if (!badgeString) return badgeString;
  const m = String(badgeString).match(/^Save\s*\$([\d.,]+)/i);
  if (!m) return badgeString;
  const usd = parseFloat(m[1]?.replace(/,/g, '')) || 0;
  return `Save ${formatDZ(usd)}`;
};
